import { flash, Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { useMutation } from "react-query";
import { EmailTemplate, WaitlistItem } from "types";
import { api } from "../../../../api/api";
import { useInvalidate } from "../../../../hooks/useInvalidation";
import { SecondaryButton } from "../../../Common/SecondaryButton";
import { PurchaseSummaryTile } from "../../../PurchaseModification/PurchaseSummaryTile";

interface InviteWaitlistModalProps {
    isOpen: boolean;
    onClose: () => void;
    item: WaitlistItem;
}

export const InviteWaitlistModal = ({ item, isOpen, onClose }: InviteWaitlistModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContent item={item} onClose={onClose} />
        </Modal>
    );
};

interface ModalContentProps {
    onClose: () => void;
    item: WaitlistItem;
}

const ModalContent = ({ item, onClose }: ModalContentProps) => {
    const invalidate = useInvalidate();

    const { mutate: sendInvitation, isLoading } = useMutation(async () => {
        await api.post(`/conversations/${item.purchase.conversation.id}/messages`, {
            arrival: item.arrival,
            meta: { template: EmailTemplate.WAITLIST_INVITED_TRAVELER },
        });
        flash.success("Invitation sent successfully");
        invalidate("purchaseItems", item.id);
        onClose();
    });

    return (
        <>
            <Modal.Header description="Your customer will receive an email inviting them to confirm and pay for their waitlisted booking.">
                Invite To Book
            </Modal.Header>

            <Modal.Body>
                <PurchaseSummaryTile purchase={item.purchase} itemId={item.id} />
            </Modal.Body>

            <Modal.Footer>
                <SecondaryButton
                    disabled={isLoading}
                    onClick={() => {
                        onClose();
                    }}
                >
                    Cancel
                </SecondaryButton>

                <SubmitButton
                    isLoading={isLoading}
                    onClick={() => {
                        sendInvitation();
                    }}
                >
                    Invite
                </SubmitButton>
            </Modal.Footer>
        </>
    );
};
